import { Component, OnInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ClientDataService } from '../../data-services/client.service';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { PackageReceiveProgressComponent } from './package.receive.progress';
import { CardModule } from 'primeng/card';

@Component({
   selector: 'package-receive-sender',
   templateUrl: './package.receive.sender.html',
   styleUrls: ['./step.css'],
   providers: [MessageService],
   imports: [Toast, CommonModule, PackageReceiveProgressComponent, CardModule]
})
export class PackageReceiveSenderComponent implements OnInit {

   package: PackageReceiveService;
   showSpinner: boolean = false;

   constructor(private clientDataService: ClientDataService,
      private packageReceiveSvc: PackageReceiveService,
      private messageService: MessageService,
      private router: Router) {
      this.package = packageReceiveSvc;
      this.package.stepnumber = 4;
   }

   ngOnInit() {
      if (!this.package.trackingNumber) {
         this.router.navigate(['package-receive-new/package-receive-scan']);
      }
   }

  nextPage() {
    if (!this.package.client) {
      this.router.navigate(['package-receive-new/package-receive-client']);
    }
    else if (!this.package.packageFound) {
      this.router.navigate(['package-receive-new/package-receive-label']);
    }
    else {
      this.router.navigate(['package-receive-new/package-receive-review']);
    }
   }

   prevPage() {
      this.router.navigate(['package-receive-new/package-receive-client']);
   }

   clearAddress() {
      this.package.FromAddress1 = null;
      this.package.FromName = null;
      this.package.FromCity = null;
      this.package.FromState = null;
      this.package.FromZipCode = null;
   }

   bypassAddress() {
      this.package.addressBypassed = true;
      this.nextPage();
   }


   clientSearchType: string;
   inClientSearch: boolean = false;
   inAddressSearch: boolean = false;
   public AddressChange(address: any) {
      this.package.FromName = address.name;
      this.package.FromAddress1 = this.getAddressPart(address, 'l', 'street_number') + ' ' + this.getAddressPart(address, 'l', 'route');
      this.package.FromCity = this.getAddressPart(address, 'l', 'locality');
      if (!this.package.FromCity) {
         this.package.FromCity = this.getAddressPart(address, 'l', 'neighborhood');
      }
      if (!this.package.FromCity) {
         this.package.FromCity = this.getAddressPart(address, 'l', 'sublocality');
      }
      this.package.FromState = this.getAddressPart(address, 's', 'administrative_area_level_1');
      this.package.FromZipCode = this.getAddressPart(address, 's', 'postal_code');
      this.clientSearchType = "location";
      this.inClientSearch = true;
      this.inAddressSearch = false;
      this.findClient();
   }

   private getAddressPart(data, part, key) {
      for (var i = 0; i < data.address_components.length; i++) {
         if (data.address_components[i].types.includes(key)) {
            if (part == 'l') {
               return data.address_components[i].long_name;
            } else {
               return data.address_components[i].short_name;
            }
         }
      }
      return '';
   }

  private findClient() {
    this.package.client = {};
    var dto: any = {};
    dto.Name = this.package.FromName;
    dto.Address1 = this.package.FromAddress1;
    dto.City = this.package.FromCity;
    dto.State = this.package.FromState;
    dto.Zip = this.package.FromZipCode;
    this.clientDataService.getClientByAddress(dto).subscribe((data: any) => {
      if (data == null) {
        this.package.client = null;
      } else {
        data.OriginalName = data.Name;
        this.package.FromName = data.Name;
        this.package.client = data;
      }
      this.showSpinner = false;
      this.nextPage();
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Package', detail: 'Error looking for Client: ' + err.status, life: 6000, closable: true, sticky: true });
        this.showSpinner = false;
        this.nextPage();
      });
  }
}
